import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AddressModel } from '@data-layer/models/common';

@Component({
  selector: 'app-search-wrapper',
  templateUrl: './search-wrapper.component.html',
  styleUrls: ['./search-wrapper.component.scss'],
})
export class SearchWrapperComponent implements OnInit, OnChanges {
  @Input() public items: any[] = [];
  @Input() public loading: boolean;
  @Output() public callback: EventEmitter<any> = new EventEmitter();
  public isOpen: boolean = false;
  constructor() {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      const { currentValue, previousValue, firstChange } = changes.items;
      this.isOpen = !firstChange && currentValue.length > 0;
    }
  }

  public changeItem(i: number, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const isfEntity = this.items[i];

    if (isfEntity) {
      const { address, identifier, identifierQualifier, name, email, phone, entityIdentifier, entityIdentifierQualifier } = isfEntity;

      if (address) {
        delete address.id;
      }

      this.callback.emit({
        address: address || new AddressModel(),
        identifier: identifier || entityIdentifier,
        identifierQualifier: identifierQualifier || entityIdentifierQualifier,
        name,
        email,
        phone,
      });
    }
  }
}
